<template>
  <div class="el-staff-files">
    <div class="el-top">
      <h2 class="title">报名信息</h2>
      <el-link class="export2excel" @click="to">返回</el-link>
    </div>
    <div class="el-query">
      <div class="left">
        <el-input
          placeholder="请输入企业名称、产品、手机号"
          v-model="listQuery.companyName"
          class="search-input"
          clearable
        />
        <el-select
          clearable
          placeholder="审核状态"
          v-model="listQuery.verifyStatus"
          class="job-status-select"
        >
          <el-option
            v-for="item in verifyStatusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          type="daterange"
          v-model="dateRange"
          @change="selectTime"
          :picker-options="pickerOptions"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="报名开始日期"
          end-placeholder="报名结束日期"
          align="right"
        >
        </el-date-picker>
        <el-button @click="getList(1)" class="search-button">搜索</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      :header-cell-style="{
        background: '#eff2f8',
        color: '#333',
        fontWeight: '400',
      }"
    >
      <el-table-column
        type="index"
        label="序号"
        width="60"
        :index="indexMethod"
        align="center"
      />
      <el-table-column label="报名编号" prop="id" width="120" />
      <el-table-column label="企业名称" prop="companyName" min-width="120" />
      <el-table-column label="产品" min-width="80" prop="productName" />
      <el-table-column label="产品类型" prop="productType" width="100" />
      <el-table-column label="联系人" prop="contactUser" width="130" />
      <el-table-column label="手机号" prop="contactPhone" width="130" />
      <el-table-column
        label="提交时间"
        prop="createTimeStr"
        min-width="100"
        :formatter="timeFormat"
      />
      <el-table-column
        label="状态"
        prop="verifyStatus"
        width="100"
        :formatter="statusFormat"
      />
      <el-table-column width="150" label="操作" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div class="operate">
            <el-link
              class="show-details"
              :underline="false"
              @click="handleQuery(scope.row)"
              >查看</el-link
            >
            <el-link
              class="show-details"
              :underline="false"
              @click="handleEdit(scope.row)"
              >审核</el-link
            >
            <el-link
              type="primary"
              size="mini"
              plain
              class="btns"
              @click="deleteActivities(scope.row.id)"
            >
              删除
            </el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="total > 0"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total,prev, pager, next"
      :current-page.sync="listQuery.page"
      :page-size="listQuery.limit"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { pageList } from "@/apis/apis";
import timeFormat from "@utils/formater";

const defaultListQuery = {
  page: 1,
  limit: 10,
  verifyStatus: "",
  companyName: "",
  startDate: null,
  endDate: null,
};
export default {
  data() {
    return {
      listQuery: Object.assign({}, defaultListQuery),
      verifyStatusArr: [
        { value: 0, label: "待审核" },
        { value: 1, label: "审核通过" },
        { value: 2, label: "审核不通过" },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, new Date()]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const start = new Date();
              start.setTime(new Date().getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, new Date()]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, new Date()]);
            },
          },
        ],
      },
      tableData: [],
      total: null,
      dateRange: null,
    };
  },
  watch: {},
  computed: {},
  methods: {
    to() {
      this.$router.go(-1);
    },
    timeFormat,
    handleEdit(row) {
      this.$router.push({ path: "/home/status", query: { id: row.id } });
    },
    handleQuery(row) {
      this.$router.push({ path: "/home/info", query: { id: row.id } });
    },
    statusFormat(row) {
      if (row.verifyStatus == 0) {
        return "待审核";
      } else if (row.verifyStatus == 1) {
        return "审核通过";
      } else {
        return "审核不通过";
      }
    },
    selectTime(val) {
      this.listQuery.startDate = val == null ? "" : val[0];
      this.listQuery.endDate = val == null ? "" : val[1];
    },
    timeFormat(row, column) {
      return this.$format.timeFormat(row.createTimeStr);
    },
    indexMethod(index) {
      index = index + 1 + (this.listQuery.page - 1) * this.listQuery.limit;
      return index;
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
        // 删除信息
    deleteActivities(id) {
      this.$confirm("此操作将永久删除该条信息,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajaxGet(`company/deletedById/${id}`).then(({ data }) => {
            console.log(data);
            if (data.code == 0) {
              this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getList(ids) {
      if(ids){
        this.listQuery.page = 1;
      }
      this.$ajaxPost("/company/pageList", this.listQuery).then((res) => {
        console.log(res);
        if (res.data.code == "0") {
          this.sum = res.data.data.sum;
          this.tableData = res.data.data.result;
          this.total = res.data.data.sum;
        } else {
          this.$message(res.data.message);
        }
      });
      // this.$api.post(pageList, this.listQuery, res => {
      //   if (res.code === '0') {
      //     this.sum = res.data.sum
      //     this.tableData = res.data.result
      //     this.total = res.data.sum
      //   }
      // })
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="less">
.el-staff-files{
  background: #fff;
  padding: 20px;
  margin-top: -10px;
}
@mixin redPoint() {
  .edu-div,
  .work-div,
  .fam-div {
    padding: 0 20px;

    h4::before {
      content: "*";
      color: red;
      margin-right: 5px;
    }
  }
  .work-div {
    h4::before {
      content: "";
    }
  }
}
.el-input__icon {
  line-height: 24px;
}
.el-range__icon {
  line-height: 24px !important;
}
.el-range-separator {
  padding: 0 !important;
  line-height: 24px !important;
}

.el-staff-files {
  .el-top {
    display: flex;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    justify-content: space-between;

    .title {
      font-size: 16px;
      font-weight: 400;
      margin: 0;
    }

    .export2excel {
      margin-right: 20px;
    }
  }

  .el-query {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;

    .search-input {
      width: 250px;
    }

    .job-status-select {
      margin-left: 10px;
      margin-right: 10px;
      width: 120px;
    }

    .search-button {
      margin-left: 10px;
      padding: 12px 25px;
      background-color: #fa524d;
      color: #fff;
    }
  }

  .el-table {
    margin-top: 15px;
  }

  .operate {
    .el-link {
      margin: 5px;
    }

    .show-details {
      color: #409eff;
    }

    .delete-staff {
      color: #fa524d;
    }
  }

  .el-table::before {
    height: 0;
  }

  .el-pagination {
    margin-top: 10px;
  }

  .el-staff-info-dialog {
    .el-dialog__body {
      padding: 0px;
    }

    @include redPoint();
  }

  .edit-dialog {
    .edit-dialog-save {
      position: absolute;
      right: 100px;
      top: 10px;
    }

    .el-table__empty-block {
      border-bottom: 1px solid #ebeef5;
    }
  }

  .inside-form {
    h4,
    .empty {
      text-align: center;
    }

    .empty {
      color: #999;
      border-bottom: 1px solid #e4e7ed;
      padding-bottom: 15px;
    }

    .el-form {
      margin-top: 15px;
      border-bottom: 1px solid #ebeef5;
    }

    .el-staff-detp-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }

    .dept-info-form {
      border-bottom: 1px solid transparent;
    }

    .el-form-item__label {
      // font-size: 13px !important;
    }

    .el-form-item {
      margin-bottom: 10px;
    }
  }

  .edit-form {
    .el-form-item {
      margin-bottom: 20px;
    }

    .edu-operate {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        margin: 0 5px;
      }
    }

    .top {
      text-align: center;

      h4 {
        margin-right: 20px;
        display: inline-block;
      }
    }
  }
}

.health-input {
  .el-input__inner {
    border: transparent;
  }
}
</style>
